import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=8e4626b8&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=ts&"
export * from "./Order.vue?vue&type=script&lang=ts&"
import style0 from "./Order.vue?vue&type=style&index=0&id=8e4626b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4626b8",
  null
  
)

export default component.exports